var donation = donation || {};

export function DonationInit() {
  (function ($) {
    /**
     * E.g
     * - sendOptimizelyEvent("Interaction - Donation Type_Monthly - SingleTab - Click")
     */
    function sendOptimizelyEvent(eventName, _tags) {
      var tags = _tags || {};
      window.optimizely.push({
        type: 'event',
        eventName: eventName,
        tags: tags,
      });
    }

    /**
     * E.g
     * - sendRevenueEvent("Revenue - Overall", 10.50)
     */
    function sendOptimizelyRevenueEvent(eventName, pounds) {
      // Value is in pounds
      // Make sure Pence is an integer.
      var pence = Math.round(pounds * 100);
      sendOptimizelyEvent(eventName, { revenue: pence, value: pounds });
    }

    // Check if page is loaded via browser back click, if so force the page to reload
    // This is to fix the wrong nudge message showing when returning
    if(performance.navigation.type == 2){
      location.reload(true);
    }

    donation = {
      formId: '#js-donation-form',
      buttonClicked: 'other',
      currentFrequency: 'Monthly',
      // We send 'click back' events to optimizely when
      // the user clicks on frequency tab, and then clicks back
      // So we must record if a user has previously clicked on a frequency tab.
      // Both initially false, one is set to true in 'setupOptimizely'
      hasSeenSingleTab: false,
      hasSeenMonthlyTab: false,
      init: function () {
        this.bindUIAction();

        // Params : staticCheck = init, element to check is in view
        this.formInView('init', '.c-donation');
      },

      setupOptimizely: function() {
         // We push analytics events to the window.optimizely global.
         // If optimizely is not enabled (because analytics cookies are not set)
         // we still want to be able to call window.optimizely.push,
         // So we make sure the global is defined.
          window.optimizely = window.optimizely || [];

        // Mark appropriate tab as having been viewed.
        if (this.currentFrequency === 'single') {
          this.hasSeenSingleTab = true;
        } else {
          // Default to monthly if nothing set.
          this.hasSeenMonthlyTab = true;
        }
        /**
         * Add optimizely 'tier' data attributes
         * to the donation radios
         * @param {collection} radios
         */
        function setTiers(radios) {
          var cashPrompts = $.map(radios, function (el, idx) {
            var $el = $(el);
            var pounds = parseFloat($el.attr('gtm-value'));
            var id = parseInt($el.val(), 10);
            return {
              pounds: pounds,
              id: id,
            };
          });
          // High - Low
          var orderedCashPrompts = cashPrompts.slice().sort(function (a, b) { return  b.pounds - a.pounds; });

          radios.each(function (idx, elem) {
            var $elem = $(elem);
            var id = parseInt($elem.val());
            var tierIndex = orderedCashPrompts.findIndex(function(prompt) {return  prompt.id === id; });
            var tiers = ['High', 'Mid', 'Low'];
            var tier = tiers[tierIndex];
            $elem.attr('data-tier', tier);
          });
        }

        setTiers($('.js-donation__single .js-donation-radios input[type="radio"]'));
        setTiers($('.js-donation__monthly .js-donation-radios input[type="radio"]'));
      },

      handlerSubmit: function (e) {
        // Either click or Enter on submit button
        if ( (e.key && e.key == 'Enter') || typeof e.key === "undefined" ) {
          e.preventDefault();
          var target = $(e.currentTarget);
          if (target.hasClass('c-btn--donate--submit-applepay')) {
            this.buttonClicked = 'ApplePay';
          } else {
            this.buttonClicked = 'other';
          }
          $(this.formId).submit();
        }
      },

      handerRadioButtonState: function() {
        if (!$('.c-donate--apple-pay').length) return false;
        if ($('input[name="donationtype"]:radio:checked').val() === 'monthly') {
          $('.c-donate--apple-pay').css({ display: 'none' });
          $('.c-donation__submit-button').css({ display: 'inline-block' });
        } else {
          $('.c-donate--apple-pay').css({ display: 'block' });
          $('.c-donation__submit-button').css({ display: 'none' });
        }
      },

      bindUIAction: function() {
        // Donation module clicks - Functions located in donation.js
        $('.c-donation__type label').on('click', $.proxy(this.donationTypeClick, this));
        $('.js-donation__single_nudge_close').on('click', $.proxy(this.hideSingleNudgeForGood, this));
        $('.c-donation-option label').on('click', $.proxy(this.donationPromptShow, this));
        $(window).on('resize', $.proxy(this.checkIfScrollIsNeeded, this));
        $(document).on('ready', $.proxy(this.setDonationDefaults, this));
        $(document).on('ready', $.proxy(this.setupOptimizely, this));
        if ($('.js-donation-form__WP_appeal').length) {
          $('#js-donation-form.js-donation-form__WP_appeal').submit($.proxy(this.wpAppealDonationSubmit, this));
        } else {
          $('#js-donation-form').submit($.proxy(this.donationSubmit, this));
        }

        // Stop submit on form enter
        $(this.formId).keypress(function (e) { if (e.key && e.key == 'Enter') { e.preventDefault(); return false; }});
        // Handle Frequency
        $(this.formId).on('keypress keydown', '.c-donation__type input[name="donationtype"]', $.proxy(this.donationTypeClick, this));
        // Handle Amount
        $(this.formId).on('keypress keydown', '.c-donation__amounts input[name="amount"]', $.proxy(this.donationPromptShow, this));

        $('.js-donation__other input').keyup($.proxy(this.donationOtherActive, this));
        $('.js-donation__other input').keypress($.proxy(this.donationOtherValidation, this));
        $('.js-donation__other input').on('blur', $.proxy(this.donationOtherBlur, this));
        $('.js-donation__other input').on('click', $.proxy(this.donationOtherClick, this));
        $('.c-donation-select label').on('click', $.proxy(this.donationSelectClick, this));
        $('.js-donation-form-header-button').on('click', $.proxy(this.donationFormDropdown, this));
        $(this.formId).on('change', 'input[name="donationtype"]:radio:checked', $.proxy(this.handerRadioButtonState, this));
        $(this.formId).on('change', 'input[name="amount"]:radio:checked', $.proxy(this.handleDonationRadioChange, this));
        $(this.formId).on('click keypress', 'button[type="submit"]', $.proxy(this.handlerSubmit, this));
        $(window).on('scroll', $.proxy(this.formInView, this));
      },

      /**
       * Triggered when a donation radio button is made active by user,
       * through click or keyboard events
       * @param {Event} e
       */
      handleDonationRadioChange: function (e) {
        /**
         * Optimizely events
         */
        var activeRadio = e.currentTarget;
        var $activeRadio = $(activeRadio);
        var pounds = parseFloat($activeRadio.attr('gtm-value'));
        var tier = $activeRadio.attr('data-tier');
        var donation_type = $('input[name=donationtype]:checked').val();
        var type = donation_type === 'monthly' ? 'Monthly' : 'Single';

        sendOptimizelyRevenueEvent("Interaction - Donation Type_" + type + " - Tier_" + tier + " - Click", pounds);
        /**
         * End optimizely events
         */
      },

      /**
       * A function triggered on type click, which is either monthly or single
       */
      donationTypeClick: function(e) {

        var type_toggle = '';

        if ( $(e.currentTarget).attr('type') == 'radio' && e.key.startsWith('Arrow')) {
          var invertedType = e.currentTarget.id === 'donation-type-monthly' ? 'single' : 'monthly';
          type_toggle = $(e.currentTarget).parent().find('label[for="donation-type-' + invertedType + '"]');
        } else {
          type_toggle = e.currentTarget;
        }

        // Store current active frequency
        var frequency = $(type_toggle).hasClass('js-donation-type-monthly') ? 'monthly' : 'single';

        // Need previous Frequency to see if we are actually switching between tabs.
        var previousFrequency = this.currentFrequency;
        this.currentFrequency = frequency;

        // Donation type has switched
        if (!$(type_toggle).hasClass('c-donation__active')) {
          //  $('.c-donation__active').removeClass('c-donation__active');

          // Check which type has been clicked, then show and hide amounts
          if ($(type_toggle).hasClass('js-donation-type-single')) {
            // Monthly -> Single
            /**
             * Optimizely events
             */
            sendOptimizelyEvent("Interaction - Donation Type_Monthly - SingleTab - " + (this.hasSeenSingleTab && frequency !== previousFrequency ? "Click_Back" : "Click"));
            this.hasSeenSingleTab = true;
            /**
             * End Optimizely events
             */

            $('.js-donation-active').removeClass('js-donation-active');
            $('.js-donation__single').addClass('js-donation-active');

            // Show/Hide payment logos
            $('.c-donation__payment-logos--monthly').removeClass('c-donation__payment-logos--show');
            $('.c-donation__payment-logos--single').addClass('c-donation__payment-logos--show');

            // Set default prompt to show
            $('.js-donation-prompt-active').removeClass('js-donation-prompt-active');

            // If other amount is active show other on switch
            if ($('.c-donation__radio-other').hasClass('c-donation__active') && $('.js-donation__single-other').length > 0) {
              $('.js-donation__single-other').addClass('js-donation-prompt-active');
            } else {
              $('.js-donation__single-2').addClass('js-donation-prompt-active');
            }

            // Set default amount as checked
            // If other amount value is left then don't set default
            if (!$('.js-donation__other input').val()) {
              $('#single-amount-2').prop('checked', true);
            }

            if ($('.c-donation__single_nudge_message').length) {
              this.showSingleNudge();
            }
          } else if ($(type_toggle).hasClass('js-donation-type-monthly')) {
            // Single -> Monthly
            /**
             * Optimizely events
             */
            sendOptimizelyEvent("Interaction - Donation Type_Single - MonthlyTab - " + (this.hasSeenMonthlyTab && frequency !== previousFrequency ? "Click_Back" : "Click"));
            this.hasSeenMonthlyTab = true;
            /**
             * End Optimizely events
             */

            $('.js-donation-active').removeClass('js-donation-active');
            $('.js-donation__monthly').addClass('js-donation-active');

            // Show/Hide payment logos
            $('.c-donation__payment-logos--monthly').addClass('c-donation__payment-logos--show');
            $('.c-donation__payment-logos--single').removeClass('c-donation__payment-logos--show');

            // Set default prompt to show
            $('.js-donation-prompt-active').removeClass('js-donation-prompt-active');

            // If other amount is active show other on switch
            if ($('.c-donation__radio-other').hasClass('c-donation__active') && $('.js-donation__monthly-other').length > 0) {
              $('.js-donation__monthly-other').addClass('js-donation-prompt-active');
            } else {
              $('.js-donation__monthly-2').addClass('js-donation-prompt-active');
            }

            // Set default amount as checked
            // If other amount value is left then don't set default
            if (!$('.js-donation__other input').val()) {
              $('#monthly-amount-2').prop('checked', true);
            }
            if ($('.c-donation__single_nudge_message').length) {
              this.hideSingleNudge();
            }
          }
        }
      },

      /**
       * A function to show the prompt, this is more info on what the donation
       * could affect, image and text.
       */
      donationPromptShow: function(e) {

        var type_toggle = '';
        if ( $(e.currentTarget).attr('type') == 'radio' && e.key.startsWith('Arrow') ) {

          var nId = e.currentTarget.id.slice(-1);
          var id = e.currentTarget.id.slice(0, -1);

          // Previous
          if (e.key == 'ArrowUp' || e.key == 'ArrowLeft') {
            if (nId == 1) { nId = 3; } else { nId--; }
          }

          // Next
          if (e.key == 'ArrowDown' || e.key == 'ArrowRight') {
            if (nId == 3) { nId = 1; } else { nId++; }
          }

          type_toggle = e.currentTarget.parentNode.parentNode.querySelector('label[for="' + id + nId.toString() + '"]');

        } else {
          type_toggle = e.currentTarget;
        }

        // Get the form as an identifier as there are now more than one form on a page
        var this_form = $(type_toggle).closest('.c-donation');

        // Remove default styling
        // console.log($(type_toggle).attr('class'));
        var clicked_class = $(type_toggle).attr('class').split(' ')[0];

        // Empty other amount if amount selected
        $('.js-donation__other input').val('');

        // hide less than £1 error
        $('.c-donation__low-amount-error').css({ display: 'none' });

        // hide over £1000 error
        $('.c-donation__exceeds-one-thousand-monthly-error').css({ display: 'none' });

        // Remove all styling
        $('.c-donation__active').removeClass('c-donation__active');
        $('.js-donation-prompt-active').removeClass('js-donation-prompt-active');
        $('.' + clicked_class)
          .not(type_toggle)
          .addClass('js-donation-prompt-active');
      },

      /**
       * A to set automatic donation defaults.
       */
      setDonationDefaults: function() {
        $('#js-donation-default').prop('checked', true);
        $('#js-donation-default-label').addClass('c-donation-other__active');
        $('.js-donation-choose').addClass('c-donation-other__active');

        // Default to monthly unless specified in cms
        var defaultType = 'monthly';
        if ($('#js-donation-form').attr('typeDefault')) {
          defaultType = $('#js-donation-form').attr('typeDefault');
        }

        // Show the nudge message straight away if single is default
        if ($('.c-donation__single_nudge_message').length && defaultType == 'single') {
          $('.c-donation__single_nudge_message').show();
        }

        // Show payment logos
        $('.c-donation__payment-logos--' + defaultType).addClass('c-donation__payment-logos--show');

        // Store current frequency so we are aware when other is active
        this.currentFrequency = defaultType;

        // Check default chosen is being display else Change

        // Set defaults, so always option open
        $('#donation-type-' + defaultType).prop('checked', true);
        // Add class to amount and open prompt
        $('#' + defaultType + '-amount-2').prop('checked', true);
        // $('.c-donation-option .js-donation__monthly-2').addClass('c-donation__active');
        $('.c-donation-prompt .js-donation__' + defaultType + '-2').addClass('js-donation-prompt-active');

        // If not currently on monthly, then default back to monthly amounts
        if (!$('.js-donation__' + defaultType).hasClass('js-donation-active')) {
          $('.js-donation-active').removeClass('js-donation-active');
          $('.js-donation__' + defaultType).addClass('js-donation-active');
        }

        // Check if single is the only selected payment type
        if (!$('.js-donation-type-monthly').length) {
          $('.js-donation__single .c-donation-option').css('display', 'block');
          $('#donation-type-single').prop('checked', true);
          // Add class to amount and open prompt
          $('#single-amount-2').prop('checked', true);
          // $('.c-donation-option .js-donation__monthly-2').addClass('c-donation__active');
          $('.c-donation-prompt .js-donation__single-2').addClass('js-donation-prompt-active');
        }

        // Add height to container to accommodate nudge message and therefore avoid background jump
        if ($('.c-donation__single_nudge_message').length) {
          var containerHeight = $('.c-hero--donation .c-donation__container').actual('outerHeight');
          var donationContentHeight = $('.c-hero--donation-content').actual('outerHeight');
          var nudgeMessageHeight = $('.c-donation__single_nudge_message').actual('outerHeight');
          var requiredHeight = donationContentHeight + nudgeMessageHeight;

          $('.c-hero--donation').removeClass('c-hero--donation--background-hidden');

          if(containerHeight < requiredHeight && $(window).width() > 641){
            var difference = requiredHeight - containerHeight + 60;
            $('.js-hero--donation').css('height', 'calc(' + difference + 'px + '+ containerHeight+'px)');
            $('.js-hero--donation').css('min-height', 'calc(' + difference + 'px + '+ containerHeight+'px)');
          }
        }

        // Add default-set class to then show labels once loaded
        $('.c-donation').addClass('default-rendered');
      },

      /**
       * A function to check values on donation form submit
       */
      donationSubmit: function() {
        var other_amount = $('.js-donation__other input').val();

        if (other_amount) {
          $('.js-donation-radios input').prop('checked', false);
        } else {
          $('.js-donation__other input').attr('name', '');
        }

        // Generic submit, check if appeal has been selected, validation needed
        // in js, due to chrome not validating hidden elements
        if ($('.js-donation__option').length) {
          if (!$('input[name=appealId]').is(':checked')) {
            $('.js-donation-choose').addClass('error');

            // Validation message if select appeal is not chosen
            if ($('.c-donation__error').length === 0) {
              $('.c-donation-select__wrapper').append('<p class="c-donation__error">Please choose an appeal</p>');
            }
            event.preventDefault();
          } else {
            var choosenAppeal = $('input[name=appealId]:checked').first();
            $('input[name="approach"]').val(choosenAppeal.attr('approachid'));
          }
        }

        // Change the form action depending on donation type
        var donation_type = $('input[name=donationtype]:checked').val();
        var actionRoot = this.buttonClicked === 'ApplePay' ? $(this.formId).attr('data-actionApplePay') : $(this.formId).attr('data-actionDefault');

        var actionPath = '';

        if (this.buttonClicked === 'ApplePay') {
          actionPath = donation_type === 'monthly' ? '/Checkout/SelectOptions' : '/Checkout/SelectOptions';
        } else {
          actionPath = donation_type === 'monthly' ? '/DirectDebit/PersonalDetails' : '/OnceOff/PersonalDetails';
        }

        $(this.formId).attr('action', actionRoot + '' + actionPath);

        //event.preventDefault();
      },

      /**
       * Submit the donation
       * The redirect URL is constructed based on user choices
       */
      wpAppealDonationSubmit: function(e) {
        /**
         * This is needed for an optimizely experiment.
         * Optimizely should set the data attribute 'data-quick-pay-enabled' to "true"
         * to enable quick pay mode.
         */
        var isQuickPayMode = Boolean($(this.formId).data("quick-pay-enabled"));


        var other_amount = $('.js-donation__other input').val();
        var donation_type = $('input[name=donationtype]:checked').val();
        var appeal_slug = $('input[name=appealSlug]').val();
        var actionRoot = $(this.formId).attr('data-actionDefault');
        var cashPointID = $('.js-donation-radios input[type="radio"]:checked').val();
        var url = '';

        //GTM push dataLayer on form submit
        var fixedDonation = $('.js-donation-radios input[type="radio"]:checked').next("label").text();
        var CTA_text = $('.c-donation__submit-button').html();
        var donationAmount = "";
        var isThereOtherAmount = false;

        if (fixedDonation) {
          donationAmount = fixedDonation.replace(/£/g, "").replace(/\s/g, "");
        }

        if ($('.js-donation__other input').val()) {
          isThereOtherAmount = true;
          donationAmount = $('.js-donation__other input').val();
        }

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "gaEvent",
          eventCategory: "Donations",
          eventAction: "Donation Start",
          eventLabel: undefined,
          eventValue: undefined,
          donationAmount: donationAmount,
          donationType: donation_type,
          otherAmount: isThereOtherAmount,
          CTA_text: CTA_text,
        });

        /**
         * Optimizely events on submit
         */
        function getType(donation_type) {
          return donation_type === 'monthly' ? 'Monthly' : 'Single';
        }

        var activeRadio = $('.js-donation__' + donation_type + ' .js-donation-radios input[type="radio"]:checked');

        var type = getType(donation_type);
        var tier = activeRadio.attr('data-tier');
        var pounds = parseFloat(donationAmount);

        // Always send this event
        sendOptimizelyRevenueEvent("Donation Start - Donation Type_" + type + " - Tier_All", pounds);

        // Tier event
        if (isThereOtherAmount) {
          sendOptimizelyRevenueEvent("Donation Start - Donation Type_" + type + " - Tier_OtherAmount", pounds);
        } else {
          sendOptimizelyRevenueEvent("Donation Start - Donation Type_" + type + " - Tier_" + tier, pounds);
        }

        /**
         * End optimizely events on submit
         */

        if (other_amount) {

          if (other_amount < 1) {
            $('.c-donation__low-amount-error').css({ display: 'block' });
          } else if (other_amount > 1000 && donation_type === 'monthly') {
            $('.c-donation__exceeds-one-thousand-monthly-error').css({ display: 'block' });

          } else {

          // fix other amount if it has more than 2 decimal place eg 7.000
           var checked_other_amount = parseFloat(other_amount).toFixed(2);

           // Quick pay variant (only works for single donations)
           if(isQuickPayMode && donation_type === 'single') {
             url = actionRoot + '/' + appeal_slug + '/variant/quick-pay/single/0/' + checked_other_amount;
           } else {
             url = actionRoot + '/' + appeal_slug + '/' + donation_type + '/0/donate/details/' + checked_other_amount;
           }
            window.location = url;
          }
        } else {
          // Quick pay variant (only works for single donations)
          if(isQuickPayMode && donation_type === 'single') {
            url = actionRoot + '/' + appeal_slug + '/variant/quick-pay/single/' + cashPointID;
          } else {
            url = actionRoot + '/' + appeal_slug + '/' + donation_type + '/' + cashPointID + '/donate/details';
          }
          window.location = url;
        }

        e.preventDefault();
      },

      /**
       * A function remove active donation states if other amount is being used
       * If other amount has value un check other radios
       */
      donationOtherActive: function(e) {

        if ( (e.key && e.key != 'Tab') || typeof e.key === "undefined" ) {

          var type_toggle = e.currentTarget;
          var currentFrequency = this.currentFrequency;

          // If value in other amount
          if ($(type_toggle).val()) {
            if ($(type_toggle).val() >= 1) {
              $('.c-donation__low-amount-error').css({ display: 'none' });
              $('.c-donation__exceeds-one-thousand-monthly-error').css({ display: 'none' });
            }

            // If frequency has other amount prompt then show
            if ($('.js-donation__' + currentFrequency + '-other').length > 0) {
              $('.c-donation__active').removeClass('c-donation__active');
              $('.js-donation-prompt-active').removeClass('js-donation-prompt-active');
              $('.js-donation__' + currentFrequency + '-other').addClass('js-donation-prompt-active');
            }

            $('.js-donation-radios input').prop('checked', false);

            // On typing give active state if value in input
            if (!$(type_toggle).hasClass('c-donation__active')) {
              $(type_toggle).addClass('c-donation__active');
            }
          } else {
            $('.c-donation__active').removeClass('c-donation__active');
            $('.js-donation-prompt-active').removeClass('js-donation-prompt-active');

            var donation_type = $('input[name=donationtype]:checked').val();

            if(donation_type == 'monthly'){
              $('#monthly-amount-2').prop('checked', true);
              $('.js-donation__monthly-2').addClass('js-donation-prompt-active');
            } else {
              $('#single-amount-2').prop('checked', true);
              $('.js-donation__single-2').addClass('js-donation-prompt-active');
            }
          }
        }
      },

      /**
       * A function that checks the input is a number or a backspace (firefox)
       */
      donationOtherValidation: function(event) {
        /* jshint ignore:start */

        var target = event.currentTarget;

        if ((event.which != 46 || target.val().indexOf('.') != -1) &&
           ((event.which < 48 || event.which > 57) &&
           (event.which != 0 && event.which != 8))) {
               event.preventDefault();
        }
        var text = target.val();

        if ((event.which == 46) && (text.indexOf('.') == -1)) {
            setTimeout(function() {
                if (target.val().substring(target.val().indexOf('.')).length > 3) {
                    target.val(target.val().substring(0, target.val().indexOf('.') + 3));
                }
            }, 1);
        }

        if ((text.indexOf('.') != -1) &&
            (text.substring(text.indexOf('.')).length > 2) &&
            (event.which != 0 && event.which != 8) &&
            (target[0].selectionStart >= text.length - 2)) {
                event.preventDefault();
        }
        /* jshint ignore:end */
      },

      /**
       * Triggered when the 'other amount' input is clicked.
       * @param {*} e
       */
      donationOtherClick: function(e) {
        var donation_type = $('input[name=donationtype]:checked').val();
        var type = donation_type === 'monthly' ? 'Monthly' : 'Single';
        sendOptimizelyEvent('Interaction - Donation Type_' + type + ' - OtherAmount - Click');
      },

      /**
       * Triggered when the 'other amount' input loses focus.
       * @param {*} e
       */
      donationOtherBlur: function (e) {
        /**
         * Optimizely events
         */
        var amountInput = e.currentTarget;
        var $amountInput = $(amountInput);

        var value = $amountInput.val();
        var pounds = parseFloat(value);

        var donation_type = $('input[name=donationtype]:checked').val();
        var type = donation_type === 'monthly' ? 'Monthly' : 'Single';

        if (Number.isFinite(pounds)) {
          // Only send event if we entered an actual number (not NaN or infinities)
          sendOptimizelyRevenueEvent("Interaction - Donation Type_" + type + " - OtherAmount - Populated", pounds);
        }
        /**
         * End Optimizely events
         */
      },

      /**
       * A function triggered on click to show donations appeal options
       */
      donationSelectClick: function(e) {
        var select = e.currentTarget;
        var menu = $(select).next('.js-donation-select__options');

        // Appeal option clicked
        if ($(select).hasClass('js-donation__option')) {
          var appeal_text = $(select).text();
          $('.js-donation-choose')
            .html(appeal_text)
            .addClass('c-donation-other__active');

          // Slide menu back up
          menu = $('.js-donation-select__options');
          menu.slideUp(500);
          menu.removeClass('menu-active');
        }

        // Top label has been clicked
        if ($(select).hasClass('js-donation-choose')) {
          // Menu open and close, only triggered on dropdown label due to use
          // of the next selector
          if (!$(menu).hasClass('menu-active')) {
            // Remove error so user loses the error color
            $(select).removeClass('error');

            // Reset the html if user is choosing a different appeal
            $(select)
              .html('Choose an appeal')
              .removeClass('c-donation-other__active');

            $(menu).addClass('menu-active');
            $(menu).slideDown(300);
          } else {
            // If there is still a chosen option then re-append this to the dropdown label
            if ($('input[name=appealId]').is(':checked')) {
              var chosen_appeal = $('input[name=appealId]:checked')
                .next('label')
                .text();
              // If closed again make the chosen appeal visible
              $(select)
                .html(chosen_appeal)
                .addClass('c-donation-other__active');
            }

            $(menu).slideUp(500);
            $(menu).removeClass('menu-active');
          }
        }
      },

      /**
       * A function triggered on click of the donation form button that
       * drops down a donation form to be accessible below the hero form
       * The form is moved from one location to the other when dropdown is clicked
       */
      donationFormDropdown: function(e) {
        var clicked = e.currentTarget;
        var headerForm = $(clicked).closest('.js-donation-form-header');
        var donationForm = $('.c-donation');

        // If the form is open
        if ($(headerForm).hasClass('donation-form-open')) {
          // Use the formInView function to check if button should still be visible
          // after the form is hidden
          var staticCheck = this.formInView(true, '.c-donation__container');

          $(headerForm).removeClass('donation-form-open');

          $(donationForm).slideUp(function() {
            $('.c-hero--donation-content').append(donationForm);

            $('.c-donation').removeClass('c-donation--enable-scroll');

            // Show so that the form is visible after it has been moved
            $(donationForm).fadeIn();
            // If the main donation form would be in view then remove button from header
            if (staticCheck === false) {
              $('.c-site-header').removeClass('c-donation-header-button-visible');
            }
          });
        }
        // If the form is not currently open
        else {

          // Hide as the animation of slide down requires display none
          $(donationForm).hide();
          $(headerForm).addClass('donation-form-open');
          $(headerForm).append(donationForm);
          $(headerForm).addClass('has_form');
          $(donationForm).slideDown(function(){
            var donationHeight = $('.donation-form-open .c-donation').actual('outerHeight');
            if((donationHeight + 60) > $(window).height()){
              $('.donation-form-open .c-donation').addClass('c-donation--enable-scroll');
            }
          });
        }
      },

      /**
       * Wait for a window resize and enable the scroll bar on the donation drop down (if required)
       */
      checkIfScrollIsNeeded: function() {
        // If the form is open
        if ($('.donation-form-open').length){
          var donationHeight = $('.c-donation__wrapper').actual('outerHeight') + 60;
          if (!$('.c-donation__single_nudge_message--closed').length) { // Check to see if nudge message has been closed for good
            var nudgeMessageHeight = $('.c-donation__single_nudge_message').actual('outerHeight');
            donationHeight = donationHeight + nudgeMessageHeight;
          }
          if((donationHeight) >= $(window).height()){
            $('.donation-form-open .c-donation').addClass('c-donation--enable-scroll');
          } else {
            $('.donation-form-open .c-donation').removeClass('c-donation--enable-scroll');
          }
        }
      },

      /**
       * Check if hero form is in view, if not dispaly donation button in header
       * this is so there is always a way to donate on screen
       */
      formInView: function(staticCheck, element) {
        // Function to check if an element is not in view
        function isNotInView(elem) {
          var docViewTop = $(window).scrollTop();
          var elemTop = $(elem).offset().top;
          var elemBottom = elemTop + $(elem).height();

          return elemBottom - 60 <= docViewTop;
        }
        // Check on donation page
        if ($('.c-donation').length) {
          // Use function parameter to check if element is in view without a
          // scroll trigger
          if (staticCheck === true) {
            return isNotInView(element);

            // This is for the init page load check, if button should be in view
          } else if (staticCheck === 'init') {
            if (isNotInView(element) === true && $('.c-donation').length) {
              $('.c-site-header').addClass('c-donation-header-button-visible');
            }
          }
        }

        // If donation form on page and donation is not in view add class to show button
        if ($('.c-donation').length && isNotInView('.c-donation') === true) {
          $('.c-site-header').addClass('c-donation-header-button-visible');
        } else {
          if ($('.c-site-header').hasClass('c-donation-header-button-visible')) {
            // Only remove class that hides button if form not open
            if (!$('.js-donation-form-header').hasClass('donation-form-open')) {
              $('.page-template-landing-page .o-site-logo').show();

              // .2s timeout due to css animation occuring to hide button
              setTimeout(function() {
                $('.c-site-header').removeClass('c-donation-header-button-visible');
              }, 200);
            }
          }
        }
      },

      /**
       * Hide the nudge message for good.
       * This only fires when user dismisses the nudge message
       */
      hideSingleNudgeForGood: function() {
        $('.c-donation__single_nudge_message').addClass('c-donation__single_nudge_message--closed');
        this.hideSingleNudge();
      },

      /**
       * Temporarily hide the nudge message
       */
      hideSingleNudge: function() {
        $('.c-donation__single_nudge_message').slideUp(300);
      },

      /**
       * Show the nudge message
       */
      showSingleNudge: function() {
        if (!$('.c-donation__single_nudge_message--closed').length) { // Check to see if nudge message has been closed for good
          $('.c-donation__single_nudge_message').slideDown(300);
          var nudgeMessageHeight = $('.c-donation__single_nudge_message').actual('outerHeight');
          var donationHeight = $('.donation-form-open .c-donation').actual('outerHeight');
          if((donationHeight + 60 + nudgeMessageHeight) > $(window).height()){
            $('.donation-form-open .c-donation').addClass('c-donation--enable-scroll');
          }
        }
      }
    };

    donation.init();

  })(jQuery);
}
